import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';

// PENDING_ACTION_COMPLETE: 'Completar el proceso de solicitud',
// PENDING_ACTION_EVALUATE: 'Hacer click en Evaluar para enviar la solicitud a las entidades financieras.', //FIXME: NON-SENSE
// PENDING_ACTION_PAY: 'Hacer click en Pagar para completar el pago.',
// PENDING_ACTION_UPLOAD_DOCUMENTS: 'Subir los documentos requeridos',
// PENDING_ACTION_REVIEW_DOCUMENTS: 'Revisar los documentos subidos',
// PENDING_ACTION_SIGN_CONTRACT: 'Firmar el contrato digitalmente',
// PENDING_ACTION_PAY_FIRST_INSTALMENT: 'Pagar primera cuota con tarjeta',

export class ActionsMap {
  static async fromPaymentMethodDetail(paymentMethodDetail: BnplPaymentMethodDetailEntity): Promise<Action[] | null> {
    if (paymentMethodDetail.isExpired()) {
      return null;
    }

    //if (paymentMethodDetail.order && paymentMethodDetail.order.status === LoanStatusExternal.CONFIRMED) {
    //}

    if (
      paymentMethodDetail.selectedProvider &&
      paymentMethodDetail.lenderRequestId &&
      !paymentMethodDetail.orderCanBeRefunded()
    ) {
      return [Action.COMPLETE_ONBOARDING, Action.PAY_FIRST_INSTALMENT, Action.CAPTURE_ORDER];
    }

    if (paymentMethodDetail.orderCanBeRefunded()) {
      return [Action.COMPLETE_ONBOARDING, Action.PAY_FIRST_INSTALMENT, Action.CAPTURE_ORDER];
    }

    return [Action.COMPLETE_ONBOARDING];
  }
}
